var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
import Cookies from 'universal-cookie';
var cookies = new Cookies();
var COOKIE_NAME = 'cordata-access-token';
var COOKIE_PARAMS = {
  maxAge: 60 * 60 * 14,
  path: '/'
};
var getAccessToken = function getAccessToken() {
  var c = cookies.get(COOKIE_NAME);
  var ls = localStorage.getItem(COOKIE_NAME);
  if (c && c !== ls) {
    localStorage.setItem(COOKIE_NAME, c);
    return c;
  }
  return ls || c;
};
var setAccessToken = function setAccessToken(accessToken) {
  var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.hostname === 'localhost' ? 'localhost' : window.location.hostname.slice(window.location.hostname.indexOf('.'));
  localStorage.setItem(COOKIE_NAME, accessToken);
  cookies.set(COOKIE_NAME, accessToken, _extends({}, COOKIE_PARAMS, {
    domain: domain
  }));
};
var removeAccessToken = function removeAccessToken() {
  var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname === 'localhost' ? 'localhost' : window.location.hostname.slice(window.location.hostname.indexOf('.'));
  localStorage.removeItem(COOKIE_NAME);
  cookies.remove(COOKIE_NAME, {
    domain: domain
  });
};
export { getAccessToken, setAccessToken, removeAccessToken };